import React from "react";
import "./termsOfService.scss"; // Optional styling

const TermsOfService = () => {
  return (
    <div className="terms-of-service-container">
      <h1>Terms of Service</h1>

      <p>
        Welcome to the Skits Olympic Brand Ambassador Dashboard in (the “Site”).
        SkitsOlympic.com, belonging to Skits Olympic, Inc. and/or its affiliates
        (“Skits Olympic”) operate the Site subject to the following terms of use
        (these “Site Terms”). By visiting the Site, you accept these Site Terms.
        Please read them carefully. In addition, when you agree to provide any
        services to or on behalf of Skits Olympic, you also will be subject to
        terms of service or other applicable agreements governing those services
        (the “Agreement”).
      </p>

      <h2>PRIVACY</h2>
      <p>
        Please review our Privacy Policy, which also governs your visit to the
        Site, to understand our practices.
      </p>

      <h2>ELECTRONIC COMMUNICATIONS</h2>
      <p>
        When you visit the Site or send e-mails to us, you are communicating
        with us electronically. Skits Olympic will communicate with you via
        phone, text message, email, or by posting materials and notices to this
        website (each such communication, “electronic communication”). You
        consent to receive electronic communications from Skits Olympic.
        Standard messaging and data rates may apply. You agree that all
        agreements, notices, disclosures and other electronic communications
        Skits Olympic provides satisfy any legal requirement that such
        communications be in writing.
      </p>

      <h2>COPYRIGHT</h2>
      <p>
        All content included on the Site, such as text, graphics, logos, button
        icons, images, audio clips, video clips, digital downloads, data
        compilations, and software, is the property of Skits Olympic or its
        content suppliers and protected by United States and international
        copyright laws. The compilation of all content on the Site is the
        exclusive property of Skits Olympic and protected by U.S. and
        international copyright laws. All software used on the Site is the
        property of Skits Olympic or its software suppliers and protected by
        United States and international copyright laws.
      </p>

      <h2>TRADEMARKS</h2>
      <p>
        In addition, other Skits Olympic graphics, logos, page headers, button
        icons, scripts, and service names are trademarks or trade dress of Skits
        Olympic in the U.S. and other countries. Skits Olympic&apos;s trademarks
        and trade dress may not be used in connection with any product or
        service that is not Skits Olympic&apos;s, in any manner that is likely
        to cause confusion among customers, or in any manner that disparages or
        discredits Skits Olympic. All other trademarks not owned by Skits
        Olympic that appear on the Site are the property of their respective
        owners, who may or may not be affiliated with, connected to, or
        sponsored by Skits Olympic.
      </p>

      <h2>PATENTS</h2>
      <p>
        One or more patents owned by Skits Olympic may apply to the Site and to
        the features and services accessible via the Site. Portions of the Site
        may operate under license of one or more patents.
      </p>

      <h2>LICENSE AND SITE ACCESS</h2>
      <p>
        Skits Olympic grants you a limited license to access and make personal
        use of the Site and not to download (other than page caching),
        translate, reverse engineer, incorporate with your own works, transfer,
        adapt, modify or make derivative works based on it, or any portion of
        it, except with express written consent of Skits Olympic. This license
        does not include any resale or commercial use of the Site or its
        contents; any derivative use of the Site or its contents; any
        downloading or copying of account information; or any use of data
        mining, robots, or similar data gathering and extraction tools. Unless
        otherwise specified by Skits Olympic in a separate license, your right
        to use any software, data, documentation or other materials that you
        access or download through the Site is subject to these Site Terms or,
        if applicable, the Agreement.
      </p>
      <p>
        The Site or any portion of the Site may not be reproduced, duplicated,
        copied, sold, resold, visited, or otherwise exploited for any purpose
        without the express written consent of Skits Olympic. You may not frame
        or utilize framing techniques to enclose any trademark, logo, or other
        proprietary information (including images, text, page layout, or form)
        of Skits Olympic without express written consent. You may not use any
        meta tags or any other “hidden text” utilizing Skits Olympic’s name or
        trademarks without the express written consent of Skits Olympic. Any
        unauthorized use immediately terminates the permission or license
        granted by Skits Olympic. All rights not expressly granted to you in
        this Agreement are reserved and retained by Skits Olympic or other
        content providers. You may use the Site or any portion of the Site only
        as permitted by law. Skits Olympic may update the Site at any time and
        without notice to you. You are granted a limited, revocable, and
        nonexclusive right to create a hyperlink to the home page of the Site,
        so long as the link does not portray Skits Olympic or its products or
        services in a false, misleading, derogatory, or otherwise offensive
        manner. You may not use any Skits Olympic logo or other proprietary
        graphic or trademark as part of the link without the express written
        consent of Skits Olympic.
      </p>

      <h2>YOUR ACCOUNT</h2>
      <p>
        If you use the Site, you are responsible for maintaining the
        confidentiality of your account and password and for restricting access
        to your computer, and you agree to accept responsibility for all
        activities that occur under your account or password. Skits Olympic
        reserves the right to refuse service, terminate accounts, remove or edit
        content in its sole discretion.
      </p>

      <h2>REVIEWS, COMMENTS, COMMUNICATIONS, AND OTHER CONTENT</h2>
      <p>
        Visitors may post reviews, comments and other content, and submit
        suggestions, ideas, comments, questions, or other information, so long
        as the content is not illegal, obscene, threatening, defamatory,
        invasive of privacy, infringing of intellectual property rights, or
        otherwise injurious to third parties or objectionable and does not
        consist of or contain software viruses, political campaigning,
        commercial solicitation, chain letters, mass mailings, or any form of
        “spam.” You may not use a false e-mail address, impersonate any person
        or entity, or otherwise mislead as to the origin of a card or other
        content. Skits Olympic reserves the right (but not the obligation) to
        remove or edit such content, but does not regularly review posted
        content. If you do post content or submit material, and unless we
        indicate otherwise, you grant Skits Olympic a nonexclusive,
        royalty-free, perpetual, irrevocable, and fully sublicensable right to
        use, reproduce, modify, adapt, publish, translate, create derivative
        works from, distribute, and display such content throughout the world in
        any media. You grant Skits Olympic and sublicensees the right to use the
        name that you submit in connection with such content, if they choose.
      </p>
      <p>
        You and third parties may be permitted to upload certain data, text,
        audio, video, images, software or other content (“Third Party Content”)
        to community areas of the Site. You acknowledge that (a) Skits Olympic
        has not tested or screened Third Party Content, (b) your use of any
        Third Party Content is at your sole risk, and (c) Third Party Content
        may be subject to separate license terms as determined by the person
        posting such Third Party Content.
      </p>
      <p>
        You represent and warrant that you own or otherwise control all of the
        rights to the content (including any Third Party Content) that you post;
        that the content is accurate; that use of the content you supply does
        not violate these Site Terms and will not cause injury to any person or
        entity; and that you will indemnify Skits Olympic for all claims
        resulting from content you supply. Skits Olympic has the right but not
        the obligation to monitor and edit or remove any activity or content.
        Skits Olympic takes no responsibility and assumes no liability for any
        content posted by you or any third party.
      </p>

      <h2>COPYRIGHT COMPLAINTS</h2>
      <p>
        Skits Olympic respects the intellectual property of others. If you
        believe that your work has been copied in a way that constitutes
        copyright infringement, please follow our Notice and Procedure for
        Making Claims of Copyright Infringement below.
      </p>

      <h2>DISCLAIMER OF WARRANTIES / CONDITIONS AND LIMITATION OF LIABILITY</h2>
      <p>
        THE SITE AND ALL INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING
        ANY SOFTWARE) AND SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO
        YOU THROUGH THE SITE ARE PROVIDED BY SKITS OLYMPIC ON AN “AS IS” AND “AS
        AVAILABLE” BASIS, UNLESS OTHERWISE SPECIFIED IN THE AGREEMENT. SKITS
        OLYMPIC MAKES NO REPRESENTATIONS OR WARRANTIES OR CONDITIONS OF ANY
        KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THE SITE OR THE
        INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING ANY SOFTWARE) OR
        SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE
        SITE, UNLESS OTHERWISE SPECIFIED IN THE AGREEMENT. YOU EXPRESSLY AGREE
        THAT YOUR USE OF THE SITE IS AT YOUR SOLE RISK. TO THE FULL EXTENT
        PERMISSIBLE BY APPLICABLE LAW, SKITS OLYMPIC DISCLAIMS ALL WARRANTIES
        AND CONDITIONS, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO,
        IMPLIED WARRANTIES AND CONDITIONS OF MERCHANTABILITY AND FITNESS FOR A
        PARTICULAR PURPOSE. SKITS OLYMPIC DOES NOT WARRANT THAT THE SITE;
        INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING ANY SOFTWARE) OR
        SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE
        SITE; ITS SERVERS; OR E-MAIL SENT FROM SKITS OLYMPIC ARE FREE OF VIRUSES
        OR OTHER HARMFUL COMPONENTS. SKITS OLYMPIC WILL NOT BE LIABLE FOR ANY
        DAMAGES OF ANY KIND ARISING FROM THE USE OF THE SITE OR FROM ANY
        INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR
        SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE
        SITE, INCLUDING BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL,
        PUNITIVE, AND CONSEQUENTIAL DAMAGES, UNLESS OTHERWISE SPECIFIED IN THE
        AGREEMENT. CERTAIN LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES
        OR CONDITIONS, OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF
        THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS,
        EXCLUSIONS, OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MIGHT HAVE
        ADDITIONAL RIGHTS.
      </p>

      <h2>APPLICABLE LAW</h2>
      <p>
        By visiting the Site, you agree that the Federal Arbitration Act,
        applicable federal law, and the laws of the State of Washington, without
        regard to principles of conflict of laws, will govern these Site Terms
        and any dispute of any sort that might arise between you and Skits
        Olympic.
      </p>

      <h2>DISPUTES</h2>
      <p>
        Any dispute or claim relating in any way to your use of the Site will be
        resolved by binding arbitration, rather than in court, except that you
        may assert claims in small claims court if your claims qualify. The
        Federal Arbitration Act and federal arbitration law apply to these Site
        Terms. There is no judge or jury in arbitration, and court review of an
        arbitration award is limited. However, an arbitrator can award on an
        individual basis the same damages and relief as a court (including
        injunctive and declaratory relief or statutory damages), and must follow
        these Site Terms as a court would.
      </p>
      <p>
        To begin an arbitration proceeding, you must send a letter requesting
        arbitration and describing your claim to our registered agent
        Corporation Service Company, iPostal1, 212 E 22nd St Cheyenne, WY, 82001
        United States. The arbitration will be conducted by the American
        Arbitration Association (“AAA”) under its rules, including the AAA's
        Supplementary Procedures for Consumer-Related Disputes. The AAA's rules
        are available at{" "}
        <a href="https://www.adr.org" target="_blank" rel="noopener noreferrer">
          www.adr.org
        </a>{" "}
        or by calling 1-800-778-7879. Payment of all filing, administration and
        arbitrator fees will be governed by the AAA's rules. Skits Olympic will
        reimburse those fees for claims totaling less than $1,000 unless the
        arbitrator determines the claims are frivolous. Likewise, Skits Olympic
        will not seek attorneys' fees and costs in arbitration unless the
        arbitrator determines the claims are frivolous. You may choose to have
        the arbitration conducted by telephone, based on written submissions, or
        in person in the county where you live or at another mutually agreed
        location.
      </p>
      <p>
        You and Skits Olympic each agree that any dispute resolution proceedings
        will be conducted only on an individual basis and not in a class,
        consolidated or representative action. If for any reason a claim
        proceeds in court rather than in arbitration, you and Skits Olympic each
        waive any right to a jury trial. You and Skits Olympic also both agree
        that you or Skits Olympic may bring suit in court to enjoin infringement
        or other misuse of intellectual property rights.
      </p>

      <h2>MODIFICATION AND SEVERABILITY</h2>
      <p>
        We reserve the right to make changes to these Site Terms (including any
        policies incorporated into these Site Terms) at any time and in our sole
        discretion, and any changes will be effective upon the earlier to occur
        of (a) emailing the revised Site Terms or policies, or notice of such
        changes, to you at your email notice address, or (b) posting of the
        revised Site Terms or policies on the Site. If any provision of these
        Site Terms is deemed invalid, void, or unenforceable for any reason,
        that provision will be deemed severable and will not affect the validity
        or enforceability of any other provision of these Site Terms.
      </p>

      <h2>OUR ADDRESS</h2>
      <p>
        Skits Olympic.com, Inc.
        <br />
        212 E 22nd St 1040
        <br />
        Cheyenne, WY 82001
      </p>

      <h2>NOTICE AND PROCEDURE FOR MAKING CLAIMS OF COPYRIGHT INFRINGEMENT</h2>
      <p>
        If you believe that your work has been copied in a way that constitutes
        copyright infringement, please provide our copyright agent the written
        information specified below:
      </p>
      <ul>
        <li>
          An electronic or physical signature of the person authorized to act on
          behalf of the owner of the copyright interest;
        </li>
        <li>
          A description of the copyrighted work that you claim has been
          infringed upon;
        </li>
        <li>
          A description of where the material that you claim is infringing is
          located on the Site;
        </li>
        <li>Your address, telephone number, and e-mail address;</li>
        <li>
          A statement by you that you have a good-faith belief that the disputed
          use is not authorized by the copyright owner, its agent, or the law;
        </li>
        <li>
          A statement by you, made under penalty of perjury, that the above
          information in your notice is accurate and that you are the copyright
          owner or authorized to act on the copyright owner’s behalf.
        </li>
      </ul>
      <p>
        Skits Olympic’s Copyright Agent for notice of claims of copyright
        infringement can be reached as follows:
      </p>
      <p>
        Copyright Agent
        <br />
        Skits Olympic.com Legal Department
        <br />
        212 E 22nd St 1040
        <br />
        Cheyenne, WY 82001
        <br />
        phone: (310) 993 - 0698
        <br />
        e-mail:{" "}
        <a href="mailto:copyright@SkitsOlympic.com">
          copyright@SkitsOlympic.com
        </a>
      </p>
      <p>
        Please note that this procedure is exclusively for notifying Skits
        Olympic that your copyrighted material has been infringed.
      </p>
    </div>
  );
};

export default TermsOfService;
